import React from 'react';
import { useDispatch } from 'react-redux';
import useRedux from 'hooks/useRedux';

import * as confirmBoxActions from './confirmBox.duck';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

let dispatcher = null;

const Main = () => {

  const [state, actions] = useRedux(confirmBoxActions);

  dispatcher = useDispatch();
  const isOpen = state.confirmBox.isOpen;
  const config = state.confirmBox.config;

  var okText = !config.okBtnText ? "OK" : config.okBtnText;
  var cancelText = !config.cancelBtnText ? "Cancel" : config.cancelBtnText;

  if (isOpen) window.addEventListener("hashchange", actions.cancelConfirm);
  else window.removeEventListener("hashchange", actions.cancelConfirm);

  return isOpen && <Dialog open maxWidth={config.maxWidth} fullWidth={config.fullWidth}>
    {config.title && <DialogTitle>{config.title}</DialogTitle>}
    <DialogContent>{config.description}</DialogContent>
    {!config.buttons && <DialogActions>
      <Button variant="outlined" color="primary" onClick={() => actions.okConfirm(config.callback)}>{okText}</Button>
      {!config.isAlert && <Button variant="outlined" color="secondary" onClick={actions.cancelConfirm}>{cancelText}</Button>}
    </DialogActions>}
    {config.buttons && <DialogActions>
      {config.buttons.map((e, i) =>
        <div>{e}</div>
      )}
    </DialogActions>}
  </Dialog>
};

export default Main;

export const openConfirm = ({ title, description, callback, isAlert, okBtnText, cancelBtnText, maxWidth, fullWidth, buttons }) => {

  dispatcher(confirmBoxActions.openConfirm({ title, description, callback, isAlert, okBtnText, cancelBtnText, maxWidth, fullWidth, buttons }));
};

export const closeConfirm = () => {
  dispatcher(confirmBoxActions.okConfirm(() => { }));
};


// WEBPACK FOOTER //
// ./src/components/confirmBox/ConfirmBox.js